export default {
    player: state => {
        return state.player;
    },
    balance: (_, getters) => {
        if (!getters.player) return;
        return getters.player.balance;
    }, 
    sweepstakesBalance: (_, getters) => {
        if (!getters.balance) return;
        return getters.balance.sweepstakes;
    }, 
    currency: (_, getters) => {
        if (!getters.balance) return;

        if (getters.sweepstakesBalance) return getters.sweepstakesBalance.entrySymbol;
        return getters.balance.currency;
    }
};



// WEBPACK FOOTER //
// ./_common/data/player/getters.js